// nearLimit — ONE shared "is this account approaching a capped quota?" rule
// (mkt-0920-dev-soft-cap-warnings, owner brainstorm 2026-09-20 22:30 PT).
//
// Storage already warns at 80% via utils/storage.js's STORAGE_WARN_PCT (its
// own bar-severity logic, kept as-is). This is the SAME threshold idea but
// generic over ANY used/cap pair — wheel counts included — so one function
// backs every "approaching your limit" surface instead of three copies of the
// same 0.8 comparison drifting apart.
//
// Pure, no React/redux/network: unit-testable on its own, same shape as
// utils/storageLimit.js's isStorageFull.

export const NEAR_LIMIT_THRESHOLD = 0.8;

/**
 * @param {number} used current usage (count or bytes).
 * @param {number|null|undefined} cap the numeric cap, or null/undefined for
 *   an uncapped tier — an uncapped tier is NEVER "near" anything.
 * @param {number} [threshold] fraction of the cap that counts as "near" (0.8
 *   = 80%). Kept a parameter, not hardcoded, so a caller can tune it without
 *   forking the function.
 * @returns {boolean} true only in the APPROACHING band: threshold <= used/cap
 *   AND used < cap. At-or-over-cap is a different, already-handled state
 *   (the existing blocking toast/dialog) — this function never re-announces
 *   it, so the two notices can't both fire for the same request.
 */
export const nearLimit = (used, cap, threshold = NEAR_LIMIT_THRESHOLD) => {
  if (cap === null || cap === undefined) return false;
  const c = Number(cap);
  const u = Number(used);
  if (!Number.isFinite(c) || c <= 0) return false;
  if (!Number.isFinite(u) || u < 0) return false;
  if (u >= c) return false;
  return u / c >= threshold;
};
